import React from 'react';

export default function TermsConditions() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '2rem 0 4rem' }}>
      <div style={{ marginBottom: '2rem' }}>
        <h1 style={{ fontFamily: 'var(--font-head)', fontSize: '2rem', fontWeight: 600, color: 'var(--text)', letterSpacing: '-.02em', marginBottom: '.5rem' }}>Terms & Conditions</h1>
        <p style={{ fontSize: '.82rem', color: 'var(--text3)', fontWeight: 300 }}>Last updated: 07 April 2026</p>
      </div>

      <Section title="1. About these terms">
        These Terms & Conditions govern your use of the Levare Health Intelligence Platform ("the Platform"), operated by Levare Wellbeing ("Levare", "we", "us"). By creating an account and using the Platform, you agree to these terms in full.
        <br /><br />
        If you do not agree to these terms, you must not use the Platform. If you have any questions, contact us at contact@levarewellbeing.com.
      </Section>

      <Section title="2. Who can use the Platform">
        The Platform is intended for use by adults aged 18 and over. By registering, you confirm that you are at least 18 years old.
        <br /><br />
        Access to the Platform is provided either directly by Levare or through your employer as part of a workplace wellbeing programme. Your access may be revoked at any time if you breach these terms.
      </Section>

      <Section title="3. Your account">
        You are responsible for keeping your login credentials secure. You must not share your account with anyone else. You are responsible for all activity that occurs under your account.
        <br /><br />
        You must provide accurate information when registering. If your details change, you should update them in your profile.
        <br /><br />
        We reserve the right to suspend or terminate your account if we believe these terms have been breached, or if your account has been inactive for more than 24 months.
      </Section>

      <Section title="4. Health data and medical disclaimer">
        <strong style={{ color: 'var(--text)' }}>The Levare Platform is a health and wellbeing tool, not a medical service.</strong>
        <br /><br />
        Nothing on this Platform — including advice from Rico (our AI advisor), health scores, flagged markers, or any other content — constitutes medical advice, diagnosis, or treatment. Always consult a qualified healthcare professional before making decisions about your health, medication, diet or exercise.
        <br /><br />
        If you are experiencing a medical emergency, call 999 immediately.
        <br /><br />
        You upload health data voluntarily. Levare is not responsible for any decisions you make based on information presented on the Platform.
      </Section>

      <Section title="5. AI-generated content">
        The Platform uses AI technology (powered by Anthropic's Claude) to generate personalised health insights, training programmes, meal plans, and advice. This content is generated automatically and may not always be accurate, complete or appropriate for your individual circumstances.
        <br /><br />
        AI-generated content should be treated as general guidance only and not as professional medical, nutritional or fitness advice. You should use your own judgement and consult qualified professionals where appropriate.
        <br /><br />
        We continually work to improve the quality of AI-generated content, but we cannot guarantee its accuracy at all times.
      </Section>

      <Section title="6. Consent to health data processing">
        By uploading health data to the Platform (including blood test results, body measurements, mental health scores and other biomarkers), you explicitly consent to Levare processing this special category data for the purpose of providing the Platform's features and services.
        <br /><br />
        This consent can be withdrawn at any time by deleting your account. Withdrawal of consent does not affect the lawfulness of processing carried out prior to withdrawal.
        <br /><br />
        Full details of how we process your data are set out in our Privacy Policy.
      </Section>

      <Section title="7. Employer access">
        If you access the Platform through an employer-sponsored programme, your employer's HR team can view anonymised, aggregated team health statistics only. Your individual health data is never shared with your employer.
        <br /><br />
        Levare will not share individually identifiable health data with your employer under any circumstances.
      </Section>

      <Section title="8. Acceptable use">
        You agree not to:
        <br /><br />
        — Use the Platform for any unlawful purpose<br />
        — Upload false, misleading or harmful information<br />
        — Attempt to access other users' data<br />
        — Interfere with or disrupt the Platform's infrastructure<br />
        — Use automated tools to scrape or extract data from the Platform<br />
        — Attempt to reverse engineer any part of the Platform
      </Section>

      <Section title="9. Intellectual property">
        All content on the Platform — including design, code, text, graphics and AI-generated outputs — is owned by or licensed to Levare Wellbeing. You may not reproduce, distribute or create derivative works from this content without our written permission.
        <br /><br />
        Health data you upload remains yours. You grant Levare a licence to process this data solely for the purpose of providing the Platform's services.
      </Section>

      <Section title="10. Limitation of liability">
        To the fullest extent permitted by law, Levare Wellbeing shall not be liable for:
        <br /><br />
        — Any health decisions made based on Platform content<br />
        — Inaccuracies in AI-generated advice, meal plans or training programmes<br />
        — Loss of data, interruption of service, or technical failures<br />
        — Any indirect, consequential or special damages arising from use of the Platform
        <br /><br />
        Our total liability to you for any claim shall not exceed the amount you have paid to Levare in the 12 months preceding the claim (or £100 if you have paid nothing).
      </Section>

      <Section title="11. Changes to the Platform and these terms">
        We may update these terms from time to time. We will notify you of material changes via email or a notice on the Platform. Continued use of the Platform after changes are made constitutes acceptance of the updated terms.
        <br /><br />
        We may also modify, suspend or discontinue any part of the Platform at any time, with reasonable notice where possible.
      </Section>

      <Section title="12. Governing law">
        These terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.
      </Section>

      <Section title="13. Contact">
        Levare Wellbeing<br />
        Email: contact@levarewellbeing.com<br />
        Website: www.levarewellbeing.com
      </Section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '2rem' }}>
      <h2 style={{ fontFamily: 'var(--font-head)', fontSize: '1.1rem', fontWeight: 500, color: 'var(--text)', marginBottom: '.75rem', letterSpacing: '-.01em' }}>{title}</h2>
      <p style={{ fontSize: '.82rem', color: 'var(--text2)', fontWeight: 300, lineHeight: 1.8 }}>{children}</p>
    </div>
  );
}
